import localeConfig from "../locales.json";

export const DEFAULT_LOCALE = localeConfig.defaultLocale;

/** @type {{ code: string, label: string, shortLabel: string, intlLocale: string, flag: string }[]} */
export const LOCALES = localeConfig.locales;

export const SUPPORTED_LOCALE_CODES = LOCALES.map((locale) => locale.code);

/** Dropdown options for admin forms */
export const LOCALE_OPTIONS = LOCALES.map((locale) => ({
  label: locale.label,
  value: locale.code
}));

/** Dropdown options for public language switcher (flags resolved separately) */
export const LOCALE_SWITCHER_OPTIONS = LOCALES.map((locale) => ({
  label: locale.shortLabel,
  value: locale.code,
  flag: locale.flag
}));

export function isSupportedLocale(value) {
  return SUPPORTED_LOCALE_CODES.includes(value);
}

export function normalizeLocale(value, fallback = DEFAULT_LOCALE) {
  return isSupportedLocale(value) ? value : fallback;
}
